import { useState } from "react";
import { useAuth } from "../hooks/useAuth.jsx";
import { Link } from "react-router-dom";
import { getImagesUrls } from "../utils/s3Utils.js";
import LoadingComponent from "./LoadingComponent.jsx";
import { useImagePreloader } from "../hooks/useImagePreLoader.jsx";
import {
  AppBar,
  Grid,
  Box,
  Container,
  Drawer,
  IconButton,
  Button,
  Link as MuiLink,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

//GET URL PRESIGNED OF IMAGES
const imageskeyRoutes = {
  s3logo: "assets/images/nh.png",
  s3delivery: "assets/icons/delivery.png",
  s3delivery2: "assets/icons/delivery2.png",
  s3uploadOrders: "assets/icons/upload.png",
  s3warehouse: "assets/icons/warehouse.png",
  s3home: "assets/icons/home.png",
  s3controlPanel: "assets/icons/control-panel.png",
  s3dashboard: "assets/icons/dashboard.png",
  s3deliveryNH: "assets/icons/delivery_nh.png",
  s3Dots: "assets/icons/dots.png",
};

const imageUrls = await getImagesUrls(imageskeyRoutes, "adminlayout");
const drawerWidth = 235;

function AdminCheckoutLayout(props) {
  const { children } = props;
  const [mobileOpen, setMobileOpen] = useState(false);

  const { user, logout } = useAuth();
  const { allImagesLoaded, timeoutReached } = useImagePreloader(
    imageUrls,
    2000
  );

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawerContent = (
    <div className="container-drawer">
      <div className="drawer-s3logo">
        <img
          src="https://static.wixstatic.com/media/d57788_abb2a20628fb49f892f533e29e46b5cd~mv2.png"
          alt="Logo NH"
          style={{ width: "175px", marginTop: "10px" }}
        />
      </div>
      <div className="container-user-info">
        <p className="flex-left fw-medium">
          Hola, {user ? user.full_name : ""}
        </p>
        <p className="flex-left fw-light">
          {user ? user.user_type.join(" | ") : ""}
        </p>
        {user?.admin_plan?.plan_name && (
          <p className="flex-left fw-light">
            Plan: {user.admin_plan.plan_name}
          </p>
        )}
      </div>
      <div className="drawer-body-container" style={{height: "100px", marginBottom: "1rem"}}>
        <List
          sx={{ width: "100%", maxWidth: 360 }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          className="custom-list"
        >
          <Link
            to={"my-account"}
            id={"link-to-account"}>
            <ListItem
              button
            >
              <ListItemText primary={"Mi Cuenta"} />
            </ListItem>
          </Link>
        </List>
      </div>

      <div className="drawer-buttons-container">
        <Link
          to={"upload-requests"}
          className="upload-requests"
          id={"link-to-new-request"}
        >
          <Button variant="contained">
            <img
              src={imageUrls.s3uploadOrders}
              alt="upload"
              className="drawer-icon"
              style={{ width: "40px" }}
            />

            <p>Carga tus órdenes</p>
          </Button>
        </Link>
      </div>
      <div className="drawer-body-container">
        <List
          sx={{ width: "100%", maxWidth: 360 }}
          component="nav"
          aria-labelledby="nested-list-subheader"
          className="custom-list"
        >
          <Link to={"/admin_checkout/dashboard"} id={"link-to-admin-dashboard"}>
            <ListItem button>
              <ListItemIcon>
                <img
                  src={imageUrls.s3dashboard}
                  alt="Dashboard"
                  className="drawer-icon"
                />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItem>
          </Link>

          <Link
            to={"/admin_checkout/delivery-resume"}
            id={"link-to-deliveries"}
          >
            <ListItem>
              <ListItemIcon>
                <img
                  src={imageUrls.s3delivery}
                  alt="Deliveries"
                  className="drawer-icon"
                />
              </ListItemIcon>
              <ListItemText primary={"Deliveries"} />
            </ListItem>
          </Link>
          <Link to={"/admin_checkout/sellers"} id={"link-to-sellers"}>
            <ListItem>
              <ListItemIcon>
                <img
                  src={imageUrls.s3Dots}
                  alt="Sellers"
                  className="drawer-icon"
                />
              </ListItemIcon>
              <ListItemText primary={"Mis Sellers"} />
            </ListItem>
          </Link>
          <Link to={"/admin_checkout/drivers"} id={"link-to-drivers"}>
            <ListItem>
              <ListItemIcon>
                <img
                  src={imageUrls.s3Dots}
                  alt="Drivers"
                  className="drawer-icon"
                />
              </ListItemIcon>
              <ListItemText primary={"Mis Drivers"} />
            </ListItem>
          </Link>
        </List>
        <MuiLink
          onClick={logout}
          className="exit-container"
          id={"button-close-session"}
        >
          <i className="material-icons-outlined">exit_to_app</i>{" "}
          <p className="exit-btn">Cerrar sesión</p>
        </MuiLink>
      </div>
    </div>
  );

  return (
    <>
      {!allImagesLoaded && !timeoutReached ? (
        <LoadingComponent />
      ) : (
        <>
          <Box sx={{ display: "flex" }}>
            <Box
              component="nav"
              sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
              aria-label="mailbox folders"
            >
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={{
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: drawerWidth,
                  },
                }}
              >
                {drawerContent}
              </Drawer>
              <Drawer
                variant="permanent"
                className="desktop-drawer"
                sx={{
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: drawerWidth,
                  },
                }}
              >
                {drawerContent}
              </Drawer>
            </Box>
            <AppBar
              className="custom-appbar"
              position="fixed"
              elevation={0}
              sx={{
                backgroundColor: "white",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
            >
              <Grid container>
                <Grid item xs={3} className="flex-center">
                  <IconButton
                    aria-label="open drawer"
                    onClick={handleDrawerToggle}
                    id={"button-open-menu"}
                  >
                    <i className="material-icons-outlined">menu</i>
                  </IconButton>
                </Grid>
                <Grid item xs={6} className="flex-center">
                  <div className="appbar-logo"></div>
                </Grid>
                <Grid item xs={3} className="flex-center"></Grid>
              </Grid>
            </AppBar>
            <Container className="app-container" maxWidth={false}>
              <main className="app-main">{children}</main>
            </Container>
          </Box>
        </>
      )}
    </>
  );
}

export default AdminCheckoutLayout;
